import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9h3th02x: FaireBrandEntity = {
  token: "b_9h3th02x",
  type: "brand",
  name: "Musee",
  avatarUrl:
    "https://cdn.faire.com/fastly/1e983aa74bf8dd1c8ab81942710611dfeae58bacb0305ec679c350da9b66ee01.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0e17c14d75171337f5261647c96ed761bb838a3d8e6885df2117bd2fbce911e2.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1e983aa74bf8dd1c8ab81942710611dfeae58bacb0305ec679c350da9b66ee01.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0e17c14d75171337f5261647c96ed761bb838a3d8e6885df2117bd2fbce911e2.png",
  location: "Canton, MS, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 139,
  isInsider: true,
  description:
    "Musee is a Mississippi-made bath and body brand crafting little moments of magic for everyday life. From whimsical bath balms to soothing soaks, shower steamers, and body care, everything we make is designed to spark joy, invite rest, and bring a touch of wonder to the routine. Thoughtful ingredients, uplifting fragrances, and beautifully playful packaging come together to create products that feel good, look good, and connect with customers of every age.\nOur commitment to quality, consistency, and care has helped us build long-lasting partnerships and a strong presence across boutiques, spas, resorts, gift shops, and specialty retailers nationwide. \nGuided by our heart-line motto, Bathe the World in Love, we create feel-good essentials that merchandise beautifully, gift effortlessly, and keep your customers coming back. With Musee, you’re offering more than a bath product—you’re sharing an experience, a moment of joy, and a reason for shoppers to return again and again.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:06.297Z",
    importedBy: "entity-db-cli",
  },
};
